import { GA_CHECKOUT_PAGE, defaultCheckoutTrackConfig } from '@common/Tracking';

export const trackCheckout = (configuration = defaultCheckoutTrackConfig) => {
    if (App.Config.Controller === GA_CHECKOUT_PAGE) {
        configuration.init();

        document.addEventListener('click', configuration.initClickHandlers);
        document.addEventListener('submit', configuration.handleSubmit);
        App.Config.GaTrackSubmit = configuration.handleSubmit;

        window.addEventListener('beforeunload', () => {
            document.removeEventListener('click', configuration.initClickHandlers);
            document.removeEventListener('submit', configuration.handleSubmit);
        });
    }
};
